import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import Stack from '@mui/material/Stack';
import { CubeDefinitionRowItem } from 'types/api/SystemTenant/AROCube/CubeBuilderTypes';
import { ModalCubeAttributeDisplayFormatProps } from './ModalCubeAttributeDisplayFormat';

interface CubeDefinitionDisplayFormatActionButtonProps extends GridRenderCellParams<CubeDefinitionRowItem> {
  setModalDisplayFormat: (
    newState: (oldState: ModalCubeAttributeDisplayFormatProps) => ModalCubeAttributeDisplayFormatProps
  ) => void;
  disabled?: boolean;
}

export function CubeDefinitionDisplayFormatActionButton(props: CubeDefinitionDisplayFormatActionButtonProps) {
  const { hasFocus, row, setModalDisplayFormat, disabled = false } = props;

  if (row.isNew) return <span />;

  const handleOnClick = () => {
    setModalDisplayFormat((previousState) => ({
      ...previousState,
      visible: true,
      cubeDefinitionItem: row,
    }));
  };

  const prefix = row.displayFormat?.prefix ?? '';
  const suffix = row.displayFormat?.suffix ?? '';
  const hasDisplayFormat = Boolean(prefix || suffix);
  const isDisabled = disabled || row.locked;

  if (hasDisplayFormat) {
    return (
      <Stack direction='row' alignItems='center' minWidth={0}>
        <IconButton onClick={handleOnClick} aria-label='Edit display format' size='small' disabled={isDisabled}>
          <ModeEditOutlineOutlinedIcon fontSize='inherit' />
        </IconButton>
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{`${prefix}123${suffix}`}</span>
      </Stack>
    );
  }

  return (
    <Button
      variant='secondary-table-panel'
      sx={{
        height: '58%',
        fontSize: '12px',
      }}
      onClick={handleOnClick}
      tabIndex={hasFocus ? 0 : -1}
      disabled={isDisabled}
      onKeyDown={(event: React.KeyboardEvent) => {
        if (event.key === ' ') {
          event.stopPropagation();
        }
      }}
    >
      Create
    </Button>
  );
}
